import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

@Component
export class ProductGallery extends ThemeComponent {

    @Ref() zoomButton!: HTMLButtonElement;
    @Prop({default: []}) zoomData!: [];

    // private breakpoint: MediaQueryList = window.matchMedia(`(min-width: 1280px)`);

    // private checkBreakpoint = () => {
    //     if (this.breakpoint.matches) {
    //         this.initZoomGallery();
    //     }
    // };

    init() {

        // The product zoom is not needed for smaller screens
        // so let's only do stuff when applicable
        this.initZoomGallery();
        // this.breakpoint.addEventListener('change', this.checkBreakpoint);

    }

    initZoomGallery() {
        if (this.zoomData.length) {

            const lightbox = new PhotoSwipeLightbox({
                dataSource: this.zoomData,
                pswpModule: () => import('photoswipe')
            });

            lightbox.init();

            this.$listen(this.zoomButton, 'click', () => {
                lightbox.loadAndOpen(0, this.zoomData, null);
            });
        }
    }
}
